import {useEffect, useState} from 'react';
import {isUnreadReady, subscribeToRunState} from './novaInvocationStore';

/**
 * The row highlight belongs to unread output only: a task whose run finished and hasn't been
 * opened yet gets its whole row tinted, not just the control. Separate from
 * useNovaInvocationState because the highlight is consumed by the row/card container, not the
 * control itself.
 */
export function useNovaRowHighlight(
	taskId: string,
	// The caller must still call this hook unconditionally on every render regardless of the
	// feature flag — Rules of Hooks forbids skipping the call itself. Passing `enabled` in lets
	// the flag-off case skip the store subscription, matching useNovaInvocationState's own
	// enabled param: every rendered row otherwise subscribes to the global event bus even with
	// the flag off, which costs a subscribe/unsubscribe per row on a page rendering hundreds.
	enabled = true
): boolean {
	const [isUnread, setIsUnread] = useState(() => enabled && isUnreadReady(taskId));

	useEffect(() => {
		if (!enabled) return undefined;
		return subscribeToRunState(taskId, () => setIsUnread(isUnreadReady(taskId)));
	}, [taskId, enabled]);

	return isUnread;
}
